import { render, staticRenderFns } from "./openInfo.vue?vue&type=template&id=15c5e98f&scoped=true"
import script from "./openInfo.vue?vue&type=script&lang=js"
export * from "./openInfo.vue?vue&type=script&lang=js"
import style0 from "./openInfo.vue?vue&type=style&index=0&id=15c5e98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5e98f",
  null
  
)

export default component.exports